/**
 * Sanitise a raw URL string so it is safe to use as an href.
 *
 * Returns `null` when the input is empty, whitespace-only, or uses a
 * disallowed protocol (e.g. `javascript:`).  Relative paths starting with
 * a single `/` and absolute HTTP(S) URLs are allowed through.
 */
export function toSafeHref(rawUrl?: string): string | null {
  if (!rawUrl) {
    return null;
  }

  const normalized = rawUrl.trim();
  if (!normalized) {
    return null;
  }

  if (normalized.startsWith('/') && !normalized.startsWith('//')) {
    return normalized;
  }

  try {
    const parsed = new URL(normalized);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return parsed.toString();
    }
  } catch {
    return null;
  }

  return null;
}
